import gql from 'graphql-tag';

export const getAllConsumerActions = gql`
  query getAllConsumerActions($input: inputConsumerActions) {
    getAllConsumerActions(input: $input) {
      count_rows
      current_page
      can_back
      can_next
      total_page
      actions {
        id
        action
        objectType
        objectId
        merchant {
          username
        }
        consumer {
          id
          username
        }
        createdDate
      }
    }
  }
`;

export const getDealById = gql`
  query getDealById($id: Int!){
    getDealById(id: $id){
      id
      consumer {
        username
      }
      merchant {
        username
      }
      cancelReason
      customCancelReason
      isMerchantCancel
    }
  }
`;
